// ======================================================================
// File Name       : LiveRegisterUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col, Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import TableHead from '../TableHead';
import { VALIDATE_TYPE } from '../../constants/index';
import { LIVE_FORMAT_NUM } from '../../constants/UsageSettingLiveConstant';

class LiveRegisterUserList extends React.Component {
  render() {
    const {
      edittingUsers,
      removeUserFromList,
      isConfirm,
      storedEdittingUserList,
      liveFormat,
      onewayLiveEntryLimit,
      twowayLiveEntryLimit,
    } = this.props;
    let thead = [
      { title: 'ログインID', sortBy: null },
      { title: 'ユーザー名', sortBy: null },
      { title: '所属グループ名', sortBy: null },
      { title: '操作', sortBy: null, width: 75 },
    ];
    if (isConfirm) {
      thead = [
        { title: 'ログインID', sortBy: null },
        { title: 'ユーザー名', sortBy: null },
        { title: '所属グループ名', sortBy: null },
      ];
    }
    let tbody = null;
    if (storedEdittingUserList && Object.keys(storedEdittingUserList).length) {
      tbody = Object.keys(storedEdittingUserList).map((userSecernId, index) => {
        const user = edittingUsers.bySecernIds[userSecernId];
        if (!user) {
          return null;
        }
        return (
          <tr key={index}>
            <td className="text-left">{user.loginId}</td>
            <td className="text-left">{user.userName}</td>
            <td className="text-left">{user.groupNames}</td>
            {!isConfirm && (
              <td className="text-center">
                <i
                  className="bi bi-trash cursor_pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    removeUserFromList(userSecernId);
                  }}
                />
              </td>
            )}
          </tr>
        );
      });
    }
    return (
      <Col sm={12} className="padding-left-right-clear">
        <RenderField
          type="requiredarray"
          name="requiredarray"
          label="ライブに招待するユーザー"
          arrayLength={tbody ? tbody.length : 0}
          validates={[VALIDATE_TYPE.REQUIRED_ARRAY, VALIDATE_TYPE.MAX_ARRAY_LENGTH]}
          keyArrayToCheck="storedEdittingUserList"
          maxLength={liveFormat === LIVE_FORMAT_NUM.ONE_WAY ? onewayLiveEntryLimit : twowayLiveEntryLimit}
        />
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
      </Col>
    );
  }
}

export default LiveRegisterUserList;
